import React from 'react';
import PropTypes from 'prop-types';
import { BaasicCheckboxTemplate } from 'themes/components';
const BaasicCheckbox = function(props) {
	return <BaasicCheckboxTemplate {...props} />;
};

BaasicCheckbox.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	onChange: PropTypes.func.isRequired,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	label: PropTypes.string,
	t: PropTypes.func,
	customLabel: PropTypes.string,
};

BaasicCheckbox.defaultProps = {
	disabled: false,
};

export default BaasicCheckbox;



// WEBPACK FOOTER //
// ./src/core/components/forms/BaasicCheckbox.js